module.exports = __webpack_public_path__ + "img/b2b-banner.55c6477c.png";